import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ProfessionalTypeEnum } from 'app/interfaces/promptuary.interface';
import { ITaxonomy } from 'app/interfaces/search.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { TaxonomyService } from 'app/services/taxonomy.service';
import { UserService } from 'app/services/user.service';
import { specialtyOptions } from 'modules/promptuary/constants/specialty-options';
import { IAppointment } from 'modules/video-conference/interfaces/appointment.interface';
import { IPromptuary } from 'shared/interfaces/promptuary.interface';
import { AppointmentService } from 'shared/services/appointment/appointment.service';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

@Component({
	selector: 'promptuary-view',
	templateUrl: './promptuary-view.component.html',
	styleUrls: ['./promptuary-view.component.scss'],
})
export class PromptuaryView implements OnInit {
	autoSaveData: IAppointment;
	sessionReasonsLabels: string[] = [];
	userId;
	task;
	@Input() promptuary: IPromptuary;
	@Input() appointmentId: string;
	@Input() clientId: string;
	@Input() psychotherapist = false;
	@Input() psychologist = false;
	@Input() isAssistanceJourney = false;
	@Input() firstName = 'cliente';
	@Output('pageLoaded') emPageLoaded = new EventEmitter<boolean>();

	constructor(
		public router: Router,
		public location: Location,
		public translate: TranslateService,
		public appointmentService: AppointmentService,
		public atService: ActionTrackerService,
		public taxonomyService: TaxonomyService,
		public userService: UserService,
		public promptuaryService: PromptuaryService
	) {}

	ngOnInit() {
		this.userId = this.userService.getUserId().then((id) => {
			this.atService.eventTracker(
				SCOPE_TYPE.Promptuary,
				SUBSCOPE_TYPE.Session,
				ITEM_TYPE.RegisteredView,
				id === this.promptuary.registeredBy
					? INTERACTION_TYPE.RegisteredByMe
					: INTERACTION_TYPE.RegisteredByOthers,
				{}
			);
		});
		this.getSessionReasonsLabels();
		// this.getTask();

		this.autoSaveData = {
			id: this.appointmentId,
			contact: {
				id: this.clientId,
			},
		};

		this.emPageLoaded.emit(true);
	}

	getSessionReasonsLabels() {
		this.taxonomyService
			.getTaxonomyList('reason')
			.toPromise()
			.then((result) => {
				this.sessionReasonsLabels = result
					.filter((result) =>
						this.promptuary.sessionReasons.includes(result.id)
					)
					.map((item) => {
						return item.name;
					});
			});
	}

	getTask() {
		this.promptuaryService
			.getProfessionalTask(this.appointmentId, this.clientId)
			.subscribe(
				(task) => {
					if (task) {
						this.task = task;
					}
				},
				() => {}
			);
	}

	goBack() {
		if (history.state.returnTo) {
			this.router.navigate([history.state.returnTo]);
			return;
		}

		this.location.back();
	}

	showPill(option: ITaxonomy) {
		this.sessionReasonsLabels.push(option.name);
	}

	private psychiatristRecordTranslation = {
		currentDiseaseHistory:
			'PROMPTUARY.EVOLUTION_RECORD.CURRENT_DISEASE_HISTORY',
		personalBackground: 'PROMPTUARY.EVOLUTION_RECORD.PERSONAL_BACKGROUND',
		familyBackground: 'PROMPTUARY.EVOLUTION_RECORD.FAMILY_BACKGROUND',
		habitsAndVices: 'PROMPTUARY.EVOLUTION_RECORD.HABITS_AND_VICES',
		medicationsAndDoses: 'PROMPTUARY.EVOLUTION_RECORD.MEDICATIONS_AND_DOSES',
	};

	getPsychiatristRecords(): { key: string; value?: string | null }[] {
		const keys = Object.keys(this.psychiatristRecordTranslation);
		const records = keys.map((key) => ({
			key,
			value: this.promptuary.serviceEvolutionPsychiatrist[key],
		}));
		return records;
	}

	getPsychiatristRecordTranslation(key: string): string {
		return this.translate.instant(this.psychiatristRecordTranslation[key]);
	}
	formatMainType() {
		if (!this.promptuary.professional) {
			return;
		}
		return this.translate.instant(
			`CONTACT.PROFESSIONAL_TYPE.${this.promptuary.professional.mainType.toUpperCase()}`
		);
	}

	getSpecialties(outcomeSpecialty: ProfessionalTypeEnum): string {
		const specialty = specialtyOptions.find(
			(option) => option.value === outcomeSpecialty
		);
		return specialty ? specialty.label : outcomeSpecialty;
	}
}
